export const markForTranslation = function(text){
    return text
}